export default __webpack_public_path__ + "static/media/transfer.af466827.png";